import { JwtClient } from "utils/jwtClient";

export const getBillSmootherConfig = async (
  billingEntityId: string,
  jwtClient: JwtClient,
): Promise<BillSmootherConfig> => {
  const response = await jwtClient.apiCall({
    path: `/payment_smoother/customer_configuration?`,
    queryParams: {
      billable_party_ref: `/billing/billing_entities/${billingEntityId}`,
    },
    throwRollBar: false,
  });
  if (response.status === 404) {
    return null;
  } else {
    const {
      data: { attributes: billSmootherConfig },
    } = await response.json();
    return billSmootherConfig;
  }
};

export const createBillSmootherConfig = async (
  billingEntityId: string,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  data: { [key: string]: any }, // TODO investigate billSmootherConfig types throughout to app
  jwtClient: JwtClient,
): Promise<BillSmootherConfig> => {
  const body = {
    billable_party_ref: `/billing/billing_entities/${billingEntityId}`,
    ...data,
  };
  const response = await jwtClient.apiCall({
    path: "/payment_smoother/customer_configuration",
    params: {
      headers: {
        Accept: "application/vnd.flick+json",
        "Content-Type": "application/vnd.flick+json",
      },
    },
    fetchParams: { method: "POST", body: JSON.stringify(body) },
  });
  const {
    data: { attributes: billSmootherConfig },
  } = await response.json();
  return billSmootherConfig;
};

export const updateBillSmootherConfig = async (
  billingEntityId: string,
  data: BillSmootherConfig,
  jwtClient: JwtClient,
): Promise<BillSmootherConfig> => {
  const body = {
    billable_party_ref: `/billing/billing_entities/${billingEntityId}`,
    ...data,
  };
  const response = await jwtClient.apiCall({
    path: "/payment_smoother/customer_configuration",
    params: {
      headers: {
        Accept: "application/vnd.flick+json",
        "Content-Type": "application/vnd.flick+json",
      },
    },
    fetchParams: { method: "PUT", body: JSON.stringify(body) },
  });
  const {
    data: { attributes: billSmootherConfig },
  } = await response.json();
  return billSmootherConfig;
};
